import { keyframes, styled } from '@mui/material/styles';
import React from 'react';

const PREFIX = 'Loading';
const classes = {
  overlay: `${PREFIX}-overlay`,
};

const spin = keyframes`100% {transform: rotate(360deg);}`;

type CustomProps = {
  small?: boolean;
};

const bounce = keyframes`
  0%, 100% {transform: scale(0.0);}
  50% {transform: scale(1.0);}
}`;

const Loader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  padding: theme.spacing(2),
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.background.main,

  [`&.${classes.overlay}`]: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    zIndex: 4000,
    backgroundColor: `${theme.palette.darkBlue.main}99`,
  },
}));

const Root = styled('div')<CustomProps>(({ small }) => ({
  ['&.loader']: {
    position: 'relative',
    width: small ? '25px' : '45px',
    height: small ? '25px' : '45px',
    borderRadius: '100%',
    margin: '25px auto',
    animation: `${spin} 2s ease-in-out infinite`,
  },
}));

const Bubble = styled('div')<CustomProps>(({ theme, small }) => ({
  position: 'absolute',
  borderRadius: '100%',
  width: small ? '15px' : '25px',
  height: small ? '15px' : '25px',
  backgroundColor: theme.palette.lightBlue.main,
  animation: `${bounce} 2s ease-in-out infinite`,
}));

type Props = {
  overlay?: boolean;
  small?: boolean;
};

const LoadingSpinner: React.FC<Props> = ({ overlay = false, small }) => {
  return (
    <Loader className={`${overlay ? classes.overlay : null}`}>
      <Root className={`loader ${overlay ? classes.overlay : null}`} small={small}>
        <Bubble
          small={small}
          className="bubble-1"
          sx={{
            top: 0,
          }}
        />
        <Bubble
          small={small}
          className="bubble-2"
          sx={{
            top: 'auto',
            bottom: '0',
            animationDelay: '-1.0s',
          }}
        />
      </Root>
    </Loader>
  );
};

export default LoadingSpinner;
